import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { GoogleRecaptchaViewStoreFactory } from 'common/module/google/recaptcha/view-store.factory';
import { StatechartStoreFactory } from 'common/module/statechart/store.factory';
import { UserSignInViewStore } from 'common/module/user/sign-in/view-store';
import { StatsTealiumProviderService } from 'common/service/stats-tealium-provider/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';

export function UserSignInViewStoreFactory(): UserSignInViewStore {
  return new UserSignInViewStore(
    EventEmitterFactory(),
    UserAuthenticationService(),
    GoogleRecaptchaViewStoreFactory(),
    StatechartStoreFactory(),
    StatsTealiumProviderService()
  );
}
